import { AiOutlineClose } from "react-icons/ai";
import {
  Badge,
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Popper,
  Fade,
  Paper,
  ClickAwayListener,
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  ListItemSecondaryAction,
  Divider,
} from "@mui/material";
import MainCard from "components/MainCard";
import React, { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { FaRegBell } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ArrowinwardIcon from "@mui/icons-material/CallReceived";
import ArrowReturnIcon from "@mui/icons-material/TurnLeft";

import { getTime, getTimeFromNow } from "utils/timeHelper";
import { useNavigate } from "react-router-dom";
import {
  combinedNotificationSelector,
  getCombinedNotificationCountThunk,
  getCombinedNotificationsThunk,
  readCombinedNotificationThunk,
} from "store/reducers/notifications/combinedNotificationsSlice";
import { readNotificationThunk } from "store/reducers/notifications/notificationsSlice";
function Notification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    if (!open) {
      dispatch(getCombinedNotificationsThunk());
    }
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const iconBackColorOpen =
    theme.palette.mode === "light" ? "grey.300" : "background.default";
  const iconBackColor =
    theme.palette.mode === "light" ? "grey.100" : "transparent";
  const avatarSX = {
    width: 36,
    height: 36,
    fontSize: "1rem",
  };
  const actionSX = {
    mt: "6px",
    ml: 1,
    top: "auto",
    right: "auto",
    alignSelf: "flex-start",

    transform: "none",
  };

  useEffect(() => {
    const intervalCall = setInterval(
      (function getCount() {
        dispatch(getCombinedNotificationCountThunk());
        return getCount;
      })(),
      60000
    );
    return () => {
      clearInterval(intervalCall);
    };
  }, []);

  const notifications = useSelector(combinedNotificationSelector.selectAll);
  const count = useSelector((state) => state.combinedNotifications.count);
  const notification_state = useSelector(
    (state) => state.combinedNotifications.status
  );

  // console.log(notifications);

  return (
    <Box sx={{ ml: 0.75 }}>
      <IconButton
        disableRipple
        color="secondary"
        sx={{
          color: "text.primary",
          bgcolor: open ? iconBackColorOpen : iconBackColor,
        }}
        ref={anchorRef}
        onClick={handleToggle}
      >
        <Badge color="primary" {...(count > 0 && { badgeContent: count })}>
          <FaRegBell />
        </Badge>
      </IconButton>
      <Popper
        placement={matchesXs ? "bottom" : "bottom-end"}
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [matchesXs ? -5 : 0, 18],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Fade in={open} {...TransitionProps}>
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: "100%",
                minWidth: 285,
                maxWidth: 420,
                [theme.breakpoints.down("md")]: {
                  maxWidth: 285,
                },
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard
                  title="Notification"
                  elevation={0}
                  border={false}
                  content={false}
                  secondary={
                    <IconButton size="small" onClick={handleToggle}>
                      <AiOutlineClose />
                    </IconButton>
                  }
                >
                  <List
                    component="nav"
                    sx={{
                      p: 0,
                      "& .MuiListItemButton-root": {
                        py: 0.5,
                        "& .MuiAvatar-root": avatarSX,
                        "& .MuiListItemSecondaryAction-root": {
                          ...actionSX,
                          position: "relative",
                        },
                      },
                    }}
                  >
                    {notifications.slice(0, 4).map((notification, index) => (
                      <Box key={index}>
                        <ListItemButton
                          sx={{
                            ...(notification.read && {
                              bgcolor: theme.palette.action.selected,
                            }),
                          }}
                          onClick={() => {
                            dispatch(
                              readCombinedNotificationThunk(notification)
                            );
                          }}
                        >
                          <ListItemAvatar>
                            {notification.type === "error" && (
                              <Avatar
                                sx={{
                                  color: "error.main",
                                  bgcolor: "error.lighter",
                                }}
                              >
                                <ErrorIcon />
                              </Avatar>
                            )}

                            {(notification.type === "stock" ||
                              notification.type === "inv_low") && (
                              <Avatar
                                sx={{
                                  color: "warning.main",
                                  bgcolor: "warning.lighter",
                                }}
                              >
                                <WarningAmberIcon />
                              </Avatar>
                            )}

                            {notification.type === "inv_transfer" && (
                              <Avatar
                                sx={{
                                  color: "success.main",
                                  bgcolor: "success.lighter",
                                }}
                              >
                                <ArrowOutwardIcon />
                              </Avatar>
                            )}
                            {notification.type === "inv_received" && (
                              <Avatar
                                sx={{
                                  color: "success.main",
                                  bgcolor: "success.lighter",
                                }}
                              >
                                <ArrowinwardIcon />
                              </Avatar>
                            )}
                            {notification.type === "inv_return" && (
                              <Avatar
                                sx={{
                                  color: "success.main",
                                  bgcolor: "success.lighter",
                                }}
                              >
                                <ArrowReturnIcon />
                              </Avatar>
                            )}
                          </ListItemAvatar>
                          {notification.type === "error" && (
                            <ListItemText
                              primary={
                                <Typography variant="h6">
                                  Error in{" "}
                                  <Typography
                                    component="span"
                                    variant="subtitle1"
                                  >
                                    {notification.machine_detail.name}
                                  </Typography>
                                  <br />
                                  {notification.message.error}
                                </Typography>
                              }
                              secondary={getTimeFromNow(
                                notification.created_date
                              )}
                            />
                          )}

                          {notification.type === "stock" && (
                            <ListItemText
                              primary={
                                <Typography variant="h6">
                                  Low stock in{" "}
                                  <Typography
                                    component="span"
                                    variant="subtitle1"
                                  >
                                    {notification.machine_detail.name}
                                  </Typography>
                                  <br />
                                  Product "{notification.message.product_name}"
                                  stock is low in tray{" "}
                                  {notification.message.tray_no} partition{" "}
                                  {notification.message.partition_no}
                                </Typography>
                              }
                              secondary={getTimeFromNow(
                                notification.created_date
                              )}
                            />
                          )}

                          {notification.type === "inv_low" && (
                            <ListItemText
                              primary={
                                <Typography variant="h6">
                                  Low stock in{" "}
                                  <Typography
                                    component="span"
                                    variant="subtitle1"
                                  >
                                    Your inventory
                                  </Typography>
                                  <br />
                                  Product "{notification.message.product_name}"
                                  items left {notification.message.qty}
                                </Typography>
                              }
                              secondary={getTimeFromNow(
                                notification.created_date
                              )}
                            />
                          )}

                          {notification.type === "inv_transfer" && (
                            <ListItemText
                              primary={
                                <Typography variant="h6">
                                  Products delivered to{" "}
                                  <Typography
                                    component="span"
                                    variant="subtitle1"
                                  >
                                    {notification.message.source}
                                  </Typography>
                                  <br />
                                  Product "{notification.message.product_name}"
                                  Qty {notification.message.qty}
                                </Typography>
                              }
                              secondary={getTimeFromNow(
                                notification.created_date
                              )}
                            />
                          )}

                          {notification.type === "inv_return" && (
                            <ListItemText
                              primary={
                                <Typography variant="h6">
                                  Products returned to{" "}
                                  <Typography
                                    component="span"
                                    variant="subtitle1"
                                  >
                                    {notification.message.source}
                                  </Typography>
                                  <br />
                                  Product "{notification.message.product_name}"
                                  Qty {notification.message.qty}
                                </Typography>
                              }
                              secondary={getTimeFromNow(
                                notification.created_date
                              )}
                            />
                          )}

                          {notification.type === "inv_received" && (
                            <ListItemText
                              primary={
                                <Typography variant="h6">
                                  Products received from{" "}
                                  <Typography
                                    component="span"
                                    variant="subtitle1"
                                  >
                                    {notification.message.source}
                                  </Typography>
                                  <br />
                                  Product "{notification.message.product_name}"
                                  Qty {notification.message.qty}
                                </Typography>
                              }
                              secondary={getTimeFromNow(
                                notification.created_date
                              )}
                            />
                          )}

                          <ListItemSecondaryAction>
                            <Typography variant="caption" noWrap>
                              {getTime(notification.created_date)}
                            </Typography>
                          </ListItemSecondaryAction>
                        </ListItemButton>
                        <Divider />
                      </Box>
                    ))}

                    <ListItemButton
                      sx={{ textAlign: "center", py: `${12}px !important` }}
                      onClick={() => {
                        navigate("notifications");
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="h6" color="primary">
                            View All
                          </Typography>
                        }
                      />
                    </ListItemButton>
                  </List>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </Box>
  );
}

export default Notification;
